export enum ClearStatus {
  DECLINED = -1,
  NOT_STARTED,
  APPROVED,
  INCOMPLETE,
}
